import gql from 'graphql-tag';

export const HOME_PAGE_PROJECTS_FRAGMENT = gql`
  fragment homePageProjects on HomePageProjectsType {
    projectsTitle
    projectsButtonText
    projectsButtonUrl
    projectsDescription
  }
`;
